import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import {
  CampusWardDetails,
  SortService,
  WardMeeting,
  HousingDataService,
  AcademicSession,
  ApprovedHousingSessionInformation,
  CampusWardsDataService
} from '../../shared';
import { MatTableDataSource } from '@angular/material/table';
import * as Config from '../../shared/tokens/constants.tokens';
import { finalize } from 'rxjs/operators';

@Component({
  templateUrl: './ward-information.component.html',
  styleUrls: ['./ward-information.component.scss']
})
export class WardInformationComponent implements OnInit {
  loading = false;
  loadingError = false;
  wardDetails: CampusWardDetails;

  meetingColumns = ['meeting', 'time', 'location'];
  meetingsDataSource = new MatTableDataSource<WardMeeting>();

  constructor(
    private route: ActivatedRoute,
    private wardService: CampusWardsDataService,
    private housingService: HousingDataService,
    private titleService: Title,
    private sorter: SortService,
    private router: Router
  ) {}

  ngOnInit() {
    const campusWardId = +this.route.snapshot.paramMap.get('campusWardId');

    // load the ward's information
    if (campusWardId) {
      this.loading = true;
      this.wardService
        .getCampusWardDetails(campusWardId)
        .pipe(
          finalize(() => (this.loading = false))
        )        
        .subscribe(
          details => this.handleWardDetails(details),
          error => (this.loadingError = true)
        );
    }
  }

  /**
   * Whether or not the loaded ward has a real unit number.
   */
  hasRealUnitNumber(): boolean {
    return (
      this.wardDetails &&
      this.wardDetails.unitNumber !== Config.Constants.unassignedUnitNumber
    );
  }

  /**
   * Gets the ward type; Married Single Ward or Single Student Ward.
   */
  getWardType(): string {
    return this.wardDetails.isForMarriedStudents
      ? 'Married Student Ward'
      : 'Single Student Ward';
  }

  /**
   * Gets things ready for the details: sets page title, sorts meetings, local wards, etc
   */
  private handleWardDetails(wardDetails: CampusWardDetails): void {
    this.wardDetails = wardDetails;
    if (this.wardDetails) {
      this.titleService.setTitle(`${this.wardDetails.name} Information`);

      // sort the meetings based on their order
      this.wardDetails.meetings.sort(this.sorter.sortWardMeetingsAsc);
      this.meetingsDataSource.data = this.wardDetails.meetings;

      // sort the local wards
      this.wardDetails.localWards.sort(this.sorter.sortLocalWardsAsc);
    } else {
      // redirect to not found
      this.router.navigate(['/404'], { skipLocationChange: true });
    }
  }
}
